/**
 * Checks if value is an integer number
 *
 * @type {(value: any) => boolean}
 */
const isInt = value => value != null && value !== "" && Number.isInteger(+value);

export default isInt;
